// Why a post (or a quoted post) is hidden behind a notice, and how that
// reads. Shared by Status and Quote.

// the reasons, most important first
export const muteReasons = ({
  userMuted,
  threadMuted,
  filterHits = [],
  bot,
  sensitive,
}) =>
  [
    userMuted && 'user',
    threadMuted && 'thread',
    filterHits.length > 0 && 'filtered',
    bot && 'bot',
    sensitive && 'nsfw',
  ].filter(Boolean)

const reasonLabel = (reason, filterHits, t) => {
  switch (reason) {
    case 'user':
      return t('status.muted_user')
    case 'thread':
      return t('status.thread_muted')
    case 'filtered':
      return t(
        'status.muted_filters',
        { name: filterHits[0].name, filterMore: filterHits.length - 1 },
        filterHits.length,
      )
    case 'bot':
      return t('status.bot_muted')
    case 'nsfw':
      return t('status.sensitive_muted')
  }
}

// the main reason, and how many more there are; null when not muted
export const muteLabel = (reasons, filterHits, t) => {
  if (reasons.length === 0) return null
  const main = reasonLabel(reasons[0], filterHits, t)
  if (reasons.length === 1) return main
  return t(
    'status.multi_reason_mute',
    { main, numReasonsMore: reasons.length - 1 },
    reasons.length - 1,
  )
}
